module.exports = "data:text/x-markdown;base64,VGhpcyBuYW1lIHJlZ2lzdHJhciBpcyBsb2NrZWQgYW5kIHdpbGwgbm90IGFjY2VwdCBhbnkgbmV3IG5hbWVzIHRvIGJlIHJlZ2lzdGVyZWQuIAoKVW5sb2NrIHRoaXMgcmVnaXN0cmFyIHRvIGJlYXQgdGhlIGxldmVsLiAKClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHA6CiogVW5kZXJzdGFuZGluZyBob3cgc3RvcmFnZSB3b3JrcwoqIFVuZGVyc3RhbmRpbmcgZGVmYXVsdCBzdG9yYWdlIHR5cGVzIGZvciBsb2NhbCB2YXJpYWJsZXMKKiBVbmRlcnN0YW5kaW5nIHRoZSBkaWZmZXJlbmNlIGJldHdlZW4gYHN0b3JhZ2VgIGFuZCBgbWVtb3J5YAo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/locked.md
// module id = 1389
// module chunks = 0